const V = (title, venue, desc, price, platform, link, highlight, dur='') =>
  ({ title, venue, desc, price, platform, link, highlight, duration: dur });

const _kl = (city, q) =>
  `https://www.klook.com/en-HK/search/?query=${encodeURIComponent(city + ' ' + q)}&aid=120105`;

export const VENUE_DB = {
  // ─── THEME PARKS ──────────────────────────────────────────────────────────
  'theme parks': {
    'Hong Kong': [
      V('香港迪士尼樂園','Hong Kong Disneyland','以魔法為主題的迪士尼主題樂園','HK$639起','官方網站','https://www.hongkongdisneyland.com/tickets/','魔雪奇緣世界','1日'),
      V('香港海洋公園','Ocean Park','結合機動遊戲與海洋生物的本地主題樂園','HK$498起','官方網站','https://www.oceanpark.com.hk/en/ticketing','極速之旅過山車','1日'),
    ],
    'Tokyo': [
      V('東京迪士尼樂園','Tokyo Disneyland','全球最受歡迎的迪士尼主題樂園之一','¥7,900–10,900','官方網站','https://www.tokyodisneyresort.jp/en/tdl/','夢幻樂園、美國小鎮大街','1日'),
      V('東京迪士尼海洋','Tokyo DisneySea','以海洋探險為主題的迪士尼公園，含幻想泉新園區','¥7,900–10,900','官方網站','https://www.tokyodisneyresort.jp/en/tds/','幻想泉（鑽石馬蹄）','1日'),
      V('富士急高地','Fuji-Q Highland','日本刺激度最高的過山車主題樂園','¥6,000起','Klook',_kl('Fuji','Fuji-Q Highland ticket'),'超級強龍、麗莎和卡斯柏','1日'),
    ],
    'Osaka': [
      V('大阪環球影城','Universal Studios Japan','哈利波特、任天堂世界及多個世界級主題園區','¥8,600–12,800','官方網站','https://www.usj.co.jp/web/en/us/tickets','任天堂世界、哈利波特','1日'),
    ],
    'Nagoya': [
      V('樂高樂園名古屋','Legoland Japan','日本首座樂高樂園，設40個遊樂設施','¥4,900起','官方網站','https://www.legoland.jp/en/','樂高城市深海探險','1日'),
      V('名古屋港水族館旁遊樂場','Nagoya Port Area','名古屋港旁主題遊樂區','¥1,000起','Klook',_kl('Nagoya','theme park amusement'),'港口景觀','半日'),
    ],
    'Seoul': [
      V('樂天世界','Lotte World','首爾市中心室內外結合主題樂園','₩62,000','官方網站','https://www.lotteworld.com/eng/main/index.do','魔法島嶼、歷史博物館','1日'),
      V('愛寶樂園','Everland','韓國最大戶外主題樂園，含動物園Safari','₩59,000','Klook',_kl('Seoul','Everland theme park'),'T-Express木製過山車','1日'),
    ],
    'Busan': [
      V('釜山樂天世界','Lotte World Adventure Busan','韓國最大海岸室外主題樂園','₩55,000','Klook',_kl('Busan','Lotte World Adventure theme park'),'摩天輪、過山車','1日'),
    ],
    'Shanghai': [
      V('上海迪士尼樂園','Shanghai Disneyland','中國首座迪士尼主題樂園','¥399–799','官方網站','https://www.shanghaidisneyresort.com/en/tickets/','奇想花園、加勒比海盜','1日'),
      V('歡樂谷上海','Happy Valley Shanghai','上海大型主題樂園，設多條過山車','¥260起','Klook',_kl('Shanghai','Happy Valley theme park'),'自由飛翔過山車','1日'),
    ],
    'Shenzhen': [
      V('華僑城歡樂谷','Happy Valley Shenzhen','深圳最大主題樂園，含水上樂園','¥250起','官方網站','https://www.happyvalley.cn/','天旋地轉、鬼屋','1日'),
      V('深圳世界之窗','Window of the World','縮小版世界景點主題公園','¥180起','Klook',_kl('Shenzhen','Window of the World theme park'),'世界建築縮影','1日'),
    ],
    'Guangzhou': [
      V('廣州長隆歡樂世界','Chimelong Paradise','亞洲最受歡迎主題樂園之一','¥280起','官方網站','https://www.chimelong.com/','十環過山車、奔馳飛象','1日'),
    ],
    'Singapore': [
      V('新加坡環球影城','Universal Studios Singapore','東南亞唯一環球影城，設7個主題園區','S$88','官方網站','https://www.rwsentosa.com/en/attractions/universal-studios-singapore/buy-tickets','變形金剛、侏羅紀公園','1日'),
      V('探險灣水上樂園','Adventure Cove Waterpark','刺激水上樂園，設彩虹礁石浮潛','S$43','官方網站','https://www.rwsentosa.com/en/attractions/adventure-cove-waterpark/buy-tickets','彩虹礁石浮潛','半日'),
    ],
    'Bangkok': [
      V('夢幻世界','Dream World','曼谷必去主題樂園，設過山車及冬雪小屋','฿700','Klook',_kl('Bangkok','Dream World theme park'),'冬雪小屋','1日'),
      V('野生世界','Safari World','開放式野生動物園，設海洋世界及鳥類表演','฿1,500','Klook',_kl('Bangkok','Safari World ticket'),'獅子、長頸鹿餵食','1日'),
    ],
    'Bali': [
      V('峇里島水上樂園','Waterbom Bali','亞洲最佳水上樂園，設多條急流滑道','IDR 395,000','官方網站','https://www.waterbom-bali.com/tickets/','Smashdown急流滑道','半日'),
    ],
    'Kuala Lumpur': [
      V('樂高樂園馬來西亞','Legoland Malaysia','東南亞首座樂高樂園','RM135起','Klook',_kl('Johor Bahru','Legoland Malaysia ticket'),'Lego City、Miniland','1日'),
      V('吉隆坡遊樂設施','KL Tower Mini Zoo & Attractions','吉隆坡塔附設迷你動物園及娛樂設施','RM100起','Klook',_kl('Kuala Lumpur','KL Tower attraction ticket'),'KL塔景觀','2小時'),
    ],
    'Taipei': [
      V('六福村主題遊樂園','Leofoo Village','台灣最知名的主題樂園，設非洲野生動物區','NT$1,099起','官方網站','https://www.leofoo.com.tw/','非洲雲霄飛車','1日'),
    ],
    'Gold Coast': [
      V('夢幻世界','Dreamworld','澳洲最大主題樂園，設過山車及動物園','A$130','官方網站','https://www.dreamworld.com.au/tickets','Big 9過山車','1日'),
      V('海洋世界','Sea World Gold Coast','黃金海岸主題水上樂園及海洋動物公園','A$120','官方網站','https://www.seaworld.com.au/','海豚及北極熊展示','1日'),
      V('華納兄弟電影世界','Warner Bros. Movie World','澳洲最受歡迎電影主題樂園','A$120','官方網站','https://www.movieworld.com.au/','DC超級英雄、蝙蝠俠過山車','1日'),
    ],
    'Los Angeles': [
      V('好萊塢環球影城','Universal Studios Hollywood','電影主題樂園，含哈利波特禁忌之旅','US$119起','官方網站','https://www.universalstudioshollywood.com/web/en/us/tickets','哈利波特世界、侏羅紀公園','1日'),
      V('迪士尼樂園加州','Disneyland California','迪士尼創始地，含星際大戰銀河邊緣','US$104起','官方網站','https://disneyland.disney.go.com/tickets/','星際大戰、加勒比海盜','1日'),
      V('諾氏漿果農場','Knotts Berry Farm','加州最古老主題樂園，含鬼屋及過山車','US$79起','官方網站','https://www.knotts.com/','Ghostrider木製過山車','1日'),
    ],
    'Dubai': [
      V('杜拜奇幻花園','Dubai Miracle Garden','全球最大天然花卉花園（11月–4月開放）','AED65起','官方網站','https://www.dubaimiraclegarden.com/','七彩花卉建築','2–3小時'),
      V('MotionGate 杜拜','MotionGate Dubai','好萊塢主題樂園，含DreamWorks電影','AED250起','Klook',_kl('Dubai','MotionGate theme park ticket'),'史瑞克、護衛隊','1日'),
    ],
    'London': [
      V('倫敦哈利波特影城','Warner Bros. Studio Tour','真實哈利波特電影拍攝地','£53','官方網站','https://www.wbstudiotour.co.uk/book/','對角巷、霍格華茲大廳','3–4小時'),
      V('樂高樂園 Windsor','Legoland Windsor','英國最受歡迎家庭主題樂園','£45起','官方網站','https://www.legoland.co.uk/plan-your-visit/tickets/','Lego City深海探險','1日'),
    ],
    'Paris': [
      V('巴黎迪士尼樂園','Disneyland Paris','歐洲最大主題樂園','€82起','官方網站','https://www.disneylandparis.com/en-gb/tickets/','太空山、幻想樂園','1日'),
    ],
    'Copenhagen': [
      V('蒂沃利花園','Tivoli Gardens','全球最古老主題樂園之一，1843年開業','DKK145起','官方網站','https://www.tivoli.dk/en/visit/prices','木製過山車、魔術秀','半日'),
    ],
    'New York': [
      V('六旗大冒險','Six Flags Great Adventure','美國最多過山車的主題樂園','US$79起','官方網站','https://www.sixflags.com/greatadventure','Kingda Ka全球最高過山車','1日'),
    ],
  },

  // ─── MUSEUMS ──────────────────────────────────────────────────────────────
  'museums': {
    'Hong Kong': [
      V('香港故宮文化博物館','香港故宮','展示900件北京故宮珍藏','HK$120','官方網站','https://www.hkpm.org.hk/en/visit/tickets','宋代汝窯瓷器','1.5–2小時'),
      V('香港太空館','香港太空館','天文展覽及全天域電影院','HK$24','官方網站','https://www.lcsd.gov.hk/CE/Museum/Space/en/web/spm/visitinformation/admission.html','全天域電影','1–2小時'),
      V('M+視覺文化博物館','M+','亞洲最大當代視覺文化博物館','HK$120','官方網站','https://www.mplus.org.hk/en/visit/tickets/','當代藝術永久藏品','2–3小時'),
    ],
    'Macau': [
      V('澳門博物館','Macau Museum','設於大炮台城堡內，展示澳門400年歷史','MOP$15','官方網站','https://www.macaumuseum.gov.mo/','葡澳融合歷史展廊','1–1.5小時'),
    ],
    'Taipei': [
      V('國立故宮博物院','National Palace Museum','全球最重要中華文物博物館，近70萬件珍藏','NT$350','官方網站','https://www.npm.gov.tw/en/Article.aspx?sNo=04008306','翠玉白菜、毛公鼎','3小時'),
    ],
    'Tokyo': [
      V('東京國立博物館','Tokyo National Museum','日本最大博物館，超過11萬件藏品','¥1,000','官方網站','https://www.tnm.jp/?lang=en','國寶級武士盔甲','2–3小時'),
      V('teamLab Planets 豐洲','teamLab Planets','全球最受歡迎沉浸式數碼藝術館','¥3,200','官方網站','https://planets.teamlab.art/tokyo/','無限水晶宇宙','1.5小時'),
      V('三鷹之森吉卜力美術館','Ghibli Museum','宮崎駿主理的龍貓主題美術館','¥1,000','官方網站','https://www.ghibli-museum.jp/en/','土星座放映室','1.5–2小時'),
    ],
    'Osaka': [
      V('大阪城天守閣','Osaka Castle','歷史名城，登天守閣俯瞰整個大阪','¥600','官方網站','https://www.osakacastle.net/english/','夜間燈光秀','1小時'),
      V('teamLab植物園大阪','teamLab Botanical Garden','日本唯一在植物園舉辦的戶外數碼藝術展','¥1,700','官方網站','https://botanicalgarden.teamlab.art/','夜間花燈','1.5小時'),
    ],
    'Kyoto': [
      V('京都國立博物館','Kyoto National Museum','收藏大量平安至江戶時代的日本藝術珍品','¥700','官方網站','https://www.kyohaku.go.jp/eng/','平常陳列館','2小時'),
    ],
    'Hiroshima': [
      V('廣島和平紀念博物館','Hiroshima Peace Memorial Museum','原子彈爆炸歷史展覽，震撼人心','¥200','官方網站','https://hpmmuseum.jp/?lang=en','爆炸前後對比、遺物展示','1.5小時'),
    ],
    'Nara': [
      V('奈良國立博物館','Nara National Museum','收藏佛教藝術及文物的重要博物館','¥700','官方網站','https://www.narahaku.go.jp/english/','奈良佛像、正倉院文物','1.5小時'),
    ],
    'Beijing': [
      V('故宮博物院','Palace Museum (Forbidden City)','全球最大古代宮殿建築群，收藏逾百萬件文物','¥60–80','官方網站','https://www.dpm.org.cn/visit.html','三大殿、御花園','3–4小時'),
      V('中國國家博物館','National Museum of China','全球最大博物館之一，超過140萬件藏品','免費（需預約）','官方網站','https://en.chnmuseum.cn/','中華文明通史展','2–3小時'),
    ],
    'Shanghai': [
      V('上海博物館','Shanghai Museum','中國最重要的博物館之一，42萬件古代藝術品','免費','官方網站','https://www.shanghaimuseum.net/en/','青銅器、陶瓷藏品','2小時'),
      V('上海科技館','Shanghai Science & Technology Museum','互動科技展覽及IMAX巨幕','¥55','官方網站','https://www.sstm.org.cn/kjg_en/','機器人、生命科學館','2小時'),
    ],
    'Seoul': [
      V('國立中央博物館','National Museum of Korea','韓國最重要博物館，30萬件歷史文物','免費','官方網站','https://www.museum.go.kr/site/eng/home','金冠、陶瓷器藏品','2小時'),
      V('國立現代美術館首爾館','MMCA Seoul','韓國最重要的現代藝術機構','₩4,000','官方網站','https://www.mmca.go.kr/eng/','韓國當代藝術精選','2小時'),
    ],
    'Singapore': [
      V('新加坡國家博物館','National Museum of Singapore','探索新加坡400年歷史','S$20','官方網站','https://www.nationalmuseum.sg/visit-us/admission','新加坡巨石、歷史展廊','2小時'),
      V('藝術科學博物館','ArtScience Museum','蓮花形建築融合藝術與科技展覽','S$20','官方網站','https://www.marinabaysands.com/museum.html','teamLab Future World','2小時'),
    ],
    'Paris': [
      V('羅浮宮','Louvre Museum','世界最大藝術博物館，蒙羅麗莎的家','€22','官方網站','https://www.louvre.fr/en/visit/tickets-subscriptions','蒙羅麗莎、斷臂維納斯','3–4小時'),
      V('奧賽美術館','Musée d\'Orsay','印象派藝術聖殿，收藏莫奈、梵高','€16','官方網站','https://www.musee-orsay.fr/en/visit/practical-information/admissions','睡蓮、星夜','2–3小時'),
    ],
    'London': [
      V('大英博物館','British Museum','世界最重要博物館之一','免費','官方網站','https://www.britishmuseum.org/visit','羅塞塔石碑、木乃伊','2–3小時'),
      V('國家自然史博物館','Natural History Museum','恐龍化石及藍鯨骨架','免費','官方網站','https://www.nhm.ac.uk/visit.html','霍普藍鯨、恐龍廳','2小時'),
      V('V&A博物館','V&A Museum','世界最大裝飾藝術及設計博物館','免費','官方網站','https://www.vam.ac.uk/visit','時裝、陶瓷、珠寶藏品','2小時'),
    ],
    'Rome': [
      V('梵蒂岡博物館','Vatican Museums','世界最重要博物館群，含西斯廷禮拜堂','€17','官方網站','https://www.museivaticani.va/content/museivaticani/en/visit.html','米開朗基羅天頂壁畫','3–4小時'),
    ],
    'Barcelona': [
      V('畢卡索博物館','Museu Picasso','收藏畢卡索早期作品','€14','官方網站','https://museupicasso.bcn.cat/en/buy-your-tickets/','《宮女》系列','1.5小時'),
      V('加泰羅尼亞國家藝術博物館','MNAC','伊比利亞半島最重要的視覺藝術藏品','€12','官方網站','https://www.museunacional.cat/en/visit','羅馬式壁畫收藏','2小時'),
    ],
    'Amsterdam': [
      V('梵高博物館','Van Gogh Museum','全球最大梵高藏品，超過200件畫作','€22','官方網站','https://www.vangoghmuseum.nl/en/visit/tickets','向日葵系列、自畫像','1.5–2小時'),
      V('荷蘭國立博物館','Rijksmuseum','荷蘭最重要博物館','€22.5','官方網站','https://www.rijksmuseum.nl/en/visit','林布蘭、維梅爾','2–3小時'),
      V('安妮之家','Anne Frank House','猶太少女安妮弗蘭克藏身處','€14','官方網站','https://www.annefrank.org/en/museum/','真實日記手稿','1小時'),
    ],
    'Vienna': [
      V('藝術史博物館','Kunsthistorisches Museum','歐洲最重要藝術博物館之一','€21','官方網站','https://www.khm.at/en/visit/tickets/','布魯蓋爾、拉斐爾','2–3小時'),
    ],
    'Prague': [
      V('布拉格城堡','Prague Castle','世界最大城堡建築群，含大教堂及黃金巷','CZK250','官方網站','https://www.hrad.cz/en/prague-castle-for-visitors/visits-and-guided-tours','聖維特大教堂','3小時'),
    ],
    'Milan': [
      V('達文西最後的晚餐','The Last Supper','達文西壁畫真跡（需提前預訂）','€15','官方網站','https://cenacolovinciano.vivaticket.it/?lang=en','達文西濕壁畫','15分鐘（限時）'),
      V('米蘭大教堂','Duomo di Milano','哥德式建築奇蹟，登頂俯瞰米蘭','€7起','官方網站','https://www.duomomilano.it/en/','天台景觀、雕像','1.5小時'),
      V('布雷拉畫廊','Pinacoteca di Brera','米蘭最重要的藝術博物館','€15','官方網站','https://pinacotecabrera.org/en/','拉斐爾、卡拉瓦喬','2小時'),
    ],
    'Florence': [
      V('烏菲茲美術館','Uffizi Gallery','全球最重要文藝復興藝術館','€20','官方網站','https://www.uffizi.it/en/the-uffizi','波提切利《春》、達文西','2–3小時'),
      V('學院美術館','Accademia Gallery','米開朗基羅大衛像真跡','€12','官方網站','https://www.galleriaaccademiafirenze.it/en/','米開朗基羅大衛像','1小時'),
    ],
    'Athens': [
      V('雅典國立考古博物館','National Archaeological Museum','全球最重要古希臘文物博物館','€12','官方網站','https://www.namuseum.gr/en/','邁錫尼黃金面具','2小時'),
    ],
    'Lisbon': [
      V('國立古代藝術館','National Museum of Ancient Art','葡萄牙最重要的藝術博物館','€6','官方網站','https://www.museuarteantiga.pt/en','波斯坦帕爾板、維米爾','1.5小時'),
    ],
    'Budapest': [
      V('匈牙利國立博物館','Hungarian National Museum','展示匈牙利1,000年歷史','HUF2,200','官方網站','https://hnm.hu/en','聖斯特凡王冠復制品','1.5小時'),
    ],
    'Berlin': [
      V('博物館島','Museum Island Berlin','五座世界級博物館聚集於同一島嶼（世界遺產）','€18起','官方網站','https://www.smb.museum/en/museums-institutions/museumsinsel-berlin/','奈費爾提蒂半身像（新博物館）','半日'),
    ],
    'Stockholm': [
      V('瓦薩號博物館','Vasa Museum','17世紀沉船真跡，全球保存最完整的古船','SEK190','官方網站','https://www.vasamuseet.se/en','64炮沉船、皇家文物','1.5小時'),
      V('北方民族博物館','Nordiska museet','北歐最大文化歷史博物館','SEK150','官方網站','https://www.nordiskamuseet.se/en','北歐傳統民俗與設計','1.5小時'),
    ],
    'Copenhagen': [
      V('路易斯安那現代藝術館','Louisiana Museum','丹麥最重要的現代藝術館，海景美到窒息','DKK165','官方網站','https://louisiana.dk/en','卡爾德、賈科梅蒂','2小時'),
    ],
    'New York': [
      V('現代藝術博物館 MoMA','MoMA','當代藝術頂級博物館，梵高星夜的家','US$30','官方網站','https://www.moma.org/visit/','星夜、坎貝爾濃湯罐頭','2–3小時'),
      V('大都會藝術博物館','The Met','美國最大藝術博物館','US$30','官方網站','https://www.metmuseum.org/visit','埃及神殿、歐洲繪畫','3–4小時'),
      V('美國自然史博物館','American Museum of Natural History','恐龍化石及宇宙展廳','US$28','官方網站','https://www.amnh.org/plan-your-visit/admissions','藍鯨模型、恐龍骨架','2小時'),
    ],
    'Los Angeles': [
      V('洛杉磯郡立美術館','LACMA','美國西岸最大藝術博物館','US$25','官方網站','https://www.lacma.org/visit','路燈裝置、印象派藏品','2小時'),
      V('蓋蒂中心','The Getty Center','山頂上的免費藝術博物館，俯瞰洛杉磯','免費（停車另計）','官方網站','https://www.getty.edu/visit/center/','梵高《蕨橋》、希臘文物','2小時'),
    ],
    'Dubai': [
      V('未來博物館','Museum of the Future','全球最美建築之一，展示未來科技','AED149','官方網站','https://museumofthefuture.ae/en/visit','未來太空站、沉浸式體驗','2小時'),
    ],
    'Istanbul': [
      V('考古博物館','Istanbul Archaeological Museums','全球重要古文明藏品，亞歷山大大帝石棺','TRY200','官方網站','https://www.istanbularkeoloji.gov.tr/en/','亞歷山大石棺','2小時'),
    ],
    'Cairo': [
      V('埃及博物館','Egyptian Museum Cairo','全球最重要古埃及文物博物館','EGP200','官方網站','https://egyptianmuseum.gov.eg/','圖坦卡門黃金面具','2–3小時'),
    ],
    'New Delhi': [
      V('國立博物館','National Museum New Delhi','印度最重要博物館，收藏五千年歷史文物','₹20起','官方網站','https://www.nationalmuseumindia.gov.in/','哈拉帕文明文物、佛像','2小時'),
    ],
    'Kuala Lumpur': [
      V('馬來西亞國家博物館','National Museum of Malaysia','探索馬來西亞歷史、文化及自然遺產','RM5','官方網站','https://www.muziumnegara.gov.my/en/','馬來甲胄及傳統工藝','1.5小時'),
      V('伊斯蘭藝術博物館','Islamic Arts Museum Malaysia','亞洲最大伊斯蘭藝術博物館','RM20','官方網站','https://www.iamm.org.my/','奧斯曼建築模型','2小時'),
    ],
  },

  // ─── ZOOS ─────────────────────────────────────────────────────────────────
  'zoos': {
    'Hong Kong': [
      V('香港動植物公園','HK Zoological & Botanical Gardens','市區中心免費動物園，設紅毛猩猩及美洲虎','免費','官方網站','https://www.lcsd.gov.hk/en/parks/hkzbg/','紅毛猩猩、美洲虎','1–1.5小時'),
    ],
    'Singapore': [
      V('新加坡動物園','Singapore Zoo','熱帶雨林開放式動物園，無籠式設計','S$48','官方網站','https://www.mandai.com/en/singapore-zoo/buy-tickets.html','開放式長頸鹿餵食','3小時'),
      V('夜間動物園','Night Safari','全球首個夜間野生動物園','S$55','官方網站','https://www.mandai.com/en/night-safari/buy-tickets.html','電車夜遊、螢火蟲','2小時'),
      V('河川生態園','River Wonders','以全球大河為主題，含大熊貓','S$42','官方網站','https://www.mandai.com/en/river-wonders/buy-tickets.html','大熊貓嘉嘉、偉偉','2小時'),
    ],
    'Tokyo': [
      V('上野動物園','Ueno Zoo','東京最古老動物園，大熊貓的家','¥600','官方網站','https://www.tokyozoo.net/ueno/english/','大熊貓雙胞胎','2小時'),
    ],
    'Taipei': [
      V('台北市立動物園','Taipei Zoo','亞洲最大動物園之一，大熊貓圓仔','NT$60','官方網站','https://www.zoo.gov.taipei/','大熊貓、無尾熊館','3小時'),
    ],
    'Chengdu': [
      V('成都大熊貓繁育研究基地','Chengdu Research Base of Giant Panda Breeding','全球最重要大熊貓保護機構','¥90起','Klook',_kl('Chengdu','Giant Panda Research Base ticket'),'幼年熊貓、滾滾','3小時'),
    ],
    'Bali': [
      V('峇里島動物園','Bali Zoo','可近距離接觸動物及與老虎合照','IDR 420,000','Klook',_kl('Bali','Bali Zoo ticket'),'與老虎合照','2小時'),
    ],
    'Sydney': [
      V('塔龍加動物園','Taronga Zoo','可俯瞰雪梨港景色的世界知名動物園','A$53','官方網站','https://taronga.org.au/sydney-zoo','無尾熊、袋鼠','3小時'),
    ],
    'Melbourne': [
      V('墨爾本動物園','Melbourne Zoo','澳洲最古老動物園，大猩猩及老虎','A$47','官方網站','https://www.zoo.org.au/melbourne','大猩猩、北方白犀牛','3小時'),
    ],
    'Gold Coast': [
      V('柯倫賓野生動物園','Currumbin Wildlife Sanctuary','澳洲最著名的原住民野生動物保護區','A$55','官方網站','https://www.cws.org.au/','袋鼠、無尾熊餵食','2小時'),
    ],
    'Dubai': [
      V('杜拜動物園','Dubai Safari Park','杜拜最大野生動物公園，設非洲及亞洲區','AED90','官方網站','https://www.dubaisafaripark.ae/','長頸鹿、白老虎','3小時'),
    ],
    'Prague': [
      V('布拉格動物園','Prague Zoo','全球排名前10的動物園之一','CZK260','官方網站','https://www.zoopraha.cz/en/visit','海馬館、北京熊貓','3小時'),
    ],
    'Kuala Lumpur': [
      V('國家動物園','Zoo Negara Malaysia','馬來西亞最大動物園，大熊貓館','RM85','官方網站','https://www.zoonegaramalaysia.my/visit-us/','大熊貓興興、靚靚','3小時'),
    ],
    'Cape Town': [
      V('波爾德斯海灘企鵝保護區','Boulders Beach Penguin Colony','南非著名非洲企鵝棲息地','ZAR200','官方網站','https://www.capepoint.co.za/','野生非洲企鵝近距離觀察','1小時'),
    ],
  },

  // ─── AQUARIUMS ────────────────────────────────────────────────────────────
  'aquariums': {
    'Hong Kong': [
      V('海洋公園海洋奇觀','Ocean Park Aquarium','亞洲最大室內水族館之一','包含海洋公園入場費','官方網站','https://www.oceanpark.com.hk/en/ticketing','拱形水底隧道','2小時'),
    ],
    'Osaka': [
      V('大阪海游館','Osaka Aquarium Kaiyukan','世界最大級水族館之一，鯨鯊主水槽','¥2,700','官方網站','https://www.kaiyukan.com/language/eng/','鯨鯊、海豚','2–3小時'),
    ],
    'Tokyo': [
      V('墨田水族館','Sumida Aquarium','東京晴空塔內的現代水族館','¥2,300','官方網站','https://www.sumida-aquarium.com/en/information/','無邊際企鵝水槽','1.5小時'),
      V('葛西海洋水族園','Tokyo Sea Life Park','黑鮪魚環形水槽','¥700','官方網站','https://www.tokyo-zoo.net/english/kasai/','黑鮪魚、企鵝','2小時'),
    ],
    'Okinawa': [
      V('沖繩美麗海水族館','Churaumi Aquarium','日本最大級水族館，鯨鯊每日定時餵食','¥2,180','官方網站','https://churaumi.okinawa/en/','鯨鯊、鬼蝠魟','2小時'),
    ],
    'Singapore': [
      V('新加坡海洋生命公園','SEA Aquarium','全球最大水族館之一','S$42','官方網站','https://www.rwsentosa.com/en/attractions/sea-aquarium','開放海洋水槽（36m長）','2小時'),
    ],
    'Sydney': [
      V('雪梨水族館','SEA LIFE Sydney Aquarium','澳洲最大水族館，含大堡礁展覽','A$54','官方網站','https://www.sydneyaquarium.com.au/tickets/','大白鯊、珊瑚礁','2小時'),
    ],
    'Kuala Lumpur': [
      V('吉隆坡水族館','Aquaria KLCC','雙子塔地下室的大型水族館','RM80','官方網站','https://aquariaklcc.com/tickets/','水下隧道、沙魚','2小時'),
    ],
    'Dubai': [
      V('杜拜水族館','Dubai Aquarium & Underwater Zoo','全球最大懸掛式水族館','AED160起','官方網站','https://www.thedubaiaquarium.com/','巨型水槽、企鵝館','1.5小時'),
    ],
    'Barcelona': [
      V('巴塞隆拿水族館','L\'Aquàrium de Barcelona','歐洲最大地中海水族館，含80m水下隧道','€21','官方網站','https://www.aquariumbcn.com/en/tickets','地中海鯊魚、海底隧道','1.5小時'),
    ],
    'Vancouver': [
      V('溫哥華水族館','Vancouver Aquarium','加拿大最大水族館，太平洋館','CAD45起','官方網站','https://www.vanaqua.org/visit/admissions','白鯨、海豚','2小時'),
    ],
    'Taipei': [
      V('基隆潮境智能海洋館','Chaojing Smart Ocean Park','北台灣大型水族館','NT$280起','Klook',_kl('Taipei Keelung','aquarium ocean park ticket'),'水下隧道、鯊魚觸摸池','1.5小時'),
    ],
    'Busan': [
      V('釜山水族館','Busan Aquarium','韓國最大水族館之一，設海底隧道','₩28,000','官方網站','https://www.busanaquarium.com/eng/','鯊魚水底隧道、水母館','1.5小時'),
    ],
    'Atlanta': [
      V('喬治亞水族館','Georgia Aquarium','全球最大水族館之一，鯨鯊及白鯨','US$50起','官方網站','https://www.georgiaaquarium.org/','鯨鯊、座頭鯨','3小時'),
    ],
  },

  // ─── EXHIBITIONS ──────────────────────────────────────────────────────────
  'exhibitions': {
    'Tokyo': [
      V('teamLab Planets 豐洲','teamLab Planets','全球最熱門沉浸式數碼藝術展','¥3,200','官方網站','https://planets.teamlab.art/tokyo/','花海、無限宇宙','1.5小時'),
      V('teamLab Borderless 麻布台','teamLab Borderless','全新旗艦數碼藝術館','¥3,800','官方網站','https://borderless.teamlab.art/amu/','巨大燈光森林','2小時'),
    ],
    'Singapore': [
      V('teamLab Future World','ArtScience Museum','新加坡藝術科學博物館沉浸式展覽','S$38','官方網站','https://www.marinabaysands.com/museum/exhibitions.html','蝴蝶林、水晶宇宙','1小時'),
    ],
    'Hong Kong': [
      V('M+展覽','M+ Museum','亞洲最大當代視覺文化博物館特展','HK$200起','官方網站','https://www.mplus.org.hk/en/visit/tickets/','當代影像與裝置藝術','2–3小時'),
    ],
    'London': [
      V('泰特現代美術館','Tate Modern','全球最多人參觀的當代藝術館','免費（特展另計）','官方網站','https://www.tate.org.uk/visit/tate-modern','渦輪大廳裝置','2小時'),
    ],
    'Seoul': [
      V('國立現代美術館首爾館','MMCA Seoul','韓國最重要的現代藝術機構','₩4,000','官方網站','https://www.mmca.go.kr/eng/','韓國當代藝術精選','2小時'),
    ],
    'Dubai': [
      V('杜拜畫框','Dubai Frame','全球最大圖框建築，連接舊城與新城景觀','AED50','官方網站','https://www.dubaiframe.ae/en','全景玻璃天橋','1小時'),
    ],
  },

  // ─── TOURIST ATTRACTIONS ──────────────────────────────────────────────────
  'tourist attractions': {
    'Hong Kong': [
      V('太平山頂','Victoria Peak','香港最著名景點，山頂纜車及全城景觀','HK$68（纜車）','Klook',_kl('Hong Kong','Victoria Peak tram ticket'),'城市360度全景','1.5小時'),
      V('香港迪士尼樂園','Hong Kong Disneyland','世界頂級主題樂園','HK$639起','官方網站','https://www.hongkongdisneyland.com/tickets/','魔雪奇緣世界','1日'),
      V('大嶼山天壇大佛','Tian Tan Buddha Lantau','全球最大戶外坐禪青銅佛像（34米）','昂坪360纜車HK$249起','Klook',_kl('Hong Kong','Ngong Ping 360 cable car ticket'),'天壇大佛、寶蓮禪寺','半日'),
    ],
    'Macau': [
      V('大三巴牌坊','Ruins of St. Paul\'s','澳門世界遺產，葡萄牙巴洛克建築遺址','免費','官方網站','https://www.wh.mo/en/site/detail/5','石制教堂立面','1小時'),
      V('澳門旅遊塔','Macau Tower','高338米觀景塔，含高空彈跳（世界最高）','MOP$155起','官方網站','https://www.macautower.com.mo/en/admission/','230米高空彈跳','1–2小時'),
      V('威尼斯人澳門','The Venetian Macao','全球最大綜合娛樂城之一，室內貢多拉','免費入場','官方網站','https://www.venetianmacao.com/','大運河購物中心','2小時'),
    ],
    'Taipei': [
      V('台北101觀景台','Taipei 101 Observatory','全球曾最高大廈，89樓戶外觀景台','NT$600','官方網站','https://www.taipei-101.com.tw/en/Obs-info.aspx','超高速電梯、夜景','1小時'),
      V('野柳地質公園','Yehliu Geopark','奇特海蝕岩石地貌，著名「女王頭」','NT$120','官方網站','https://www.ylgeopark.org.tw/en/','女王頭岩、燭台石','1.5小時'),
      V('九份老街','Jiufen Old Street','山城茶樓景觀，宮崎駿《神隱少女》靈感地','免費','Klook',_kl('Taipei','Jiufen old street tour'),'茶樓景觀、九份小吃','半日'),
    ],
    'Tokyo': [
      V('淺草寺','Senso-ji Temple','東京最古老寺廟，仲見世商店街','免費','Klook',_kl('Tokyo','Asakusa Senso-ji temple tour'),'雷門大燈籠、仲見世','1.5小時'),
      V('東京晴空塔','Tokyo Skytree','世界第二高塔，450米天望台','¥3,100起','官方網站','https://www.tokyo-skytree.jp/en/ticket/','天望台夜景、天望迴廊','1小時'),
      V('新宿御苑','Shinjuku Gyoen','東京最美公園，春季賞櫻名所','¥500','官方網站','https://fng.or.jp/shinjuku/enq/en/','溫室花園、法式庭園','1.5小時'),
    ],
    'Osaka': [
      V('道頓堀','Dotonbori','大阪最著名夜生活及美食街，格力高跑者','免費','Klook',_kl('Osaka','Dotonbori food tour night'),'格力高霓虹、章魚燒','1.5小時'),
      V('大阪城公園','Osaka Castle Park','日本最重要城堡之一，春季賞櫻','¥600（天守閣）','官方網站','https://www.osakacastle.net/english/','天守閣、護城河','1.5小時'),
      V('環球影城','Universal Studios Japan','哈利波特、任天堂世界','¥8,600起','官方網站','https://www.usj.co.jp/web/en/us/tickets','任天堂世界、哈利波特','1日'),
    ],
    'Kyoto': [
      V('伏見稻荷大社','Fushimi Inari Taisha','千座鳥居通道，日本最受歡迎景點之一','免費','Klook',_kl('Kyoto','Fushimi Inari shrine tour'),'千鳥居隧道、稻荷山','2小時'),
      V('嵐山竹林','Arashiyama Bamboo Grove','京都著名竹林步道，世界知名景點','免費','Klook',_kl('Kyoto','Arashiyama bamboo grove tour'),'翠綠竹林隧道','1小時'),
      V('金閣寺','Kinkaku-ji Temple','鑲金頂的禪宗佛寺，京都最著名景點','¥500','官方網站','https://www.shokoku-ji.jp/en/kinkakuji/','黃金倒影水面','45分鐘'),
    ],
    'Hiroshima': [
      V('廣島和平紀念公園','Hiroshima Peace Memorial Park','反思原子彈爆炸歷史的世界遺產公園','免費','官方網站','https://www.pcf.city.hiroshima.jp/en/','原爆圓頂、和平之火','1.5小時'),
      V('宮島嚴島神社','Itsukushima Shrine','海上大鳥居，日本三景之一','¥300','Klook',_kl('Hiroshima','Miyajima Island Itsukushima shrine'),'海上鳥居、楓葉','半日'),
    ],
    'Nara': [
      V('奈良公園自由鹿','Nara Park Sacred Deer','與逾千頭自由行走神鹿互動','免費（餅乾¥200）','Klook',_kl('Nara','deer park feeding experience'),'餵食神鹿','1小時'),
      V('東大寺','Todai-ji Temple','全球最大木結構建築，巨型奈良大佛','¥600','官方網站','https://www.todaiji.or.jp/english/','15米高金銅大佛','1小時'),
    ],
    'Fukuoka': [
      V('太宰府天滿宮','Dazaifu Tenmangu Shrine','日本最重要學業神社之一','免費','Klook',_kl('Fukuoka','Dazaifu Tenmangu shrine tour'),'梅花苑、神牛','1小時'),
      V('博多運河城','Canal City Hakata','福岡最大購物娛樂城，設噴水秀','免費入場','官方網站','https://canalcity.co.jp/','音樂噴泉秀','1.5小時'),
    ],
    'Sapporo': [
      V('札幌電視塔','Sapporo TV Tower','大通公園地標，展望台俯瞰城市','¥700','官方網站','https://www.tv-tower.co.jp/en/','大通公園全景、雪景','45分鐘'),
      V('小樽運河','Otaru Canal','北海道最著名景點，石造倉庫群煤氣燈','免費','Klook',_kl('Sapporo Otaru','canal gas lamp night tour'),'夜間煤氣燈運河景觀','1小時'),
    ],
    'Okinawa': [
      V('首里城','Shuri Castle','琉球王國世界遺產城堡（正在修復）','¥820','官方網站','https://oki-park.jp/shurijo/en','朱紅色琉球城堡','1.5小時'),
      V('美國村','American Village Chatan','沖繩最熱門購物及娛樂街區','免費','Klook',_kl('Okinawa','American Village Chatan shopping'),'摩天輪、購物、夜市','2小時'),
    ],
    'Seoul': [
      V('景福宮','Gyeongbokgung Palace','朝鮮王朝最重要宮殿，守門將換崗儀式','₩3,000','官方網站','https://www.royalpalace.go.kr/content/royalpalace/main/eng/main.asp','守門將換崗、宮殿建築','1.5小時'),
      V('北村韓屋村','Bukchon Hanok Village','首爾傳統韓式建築村落','免費','Klook',_kl('Seoul','Bukchon Hanok Village walking tour'),'傳統韓屋街道','1小時'),
      V('南山首爾塔','N Seoul Tower','首爾最著名地標，俯瞰全城景色','₩21,000','官方網站','https://www.nseoultower.com/eng/','戀人鎖、城市全景','1小時'),
    ],
    'Busan': [
      V('海雲台海灘','Haeundae Beach','韓國最著名海灘','免費','Klook',_kl('Busan','Haeundae beach activities'),'金色沙灘、海邊咖啡','2小時'),
      V('甘川文化村','Gamcheon Culture Village','「韓國馬丘比丘」彩色山城村落','免費','Klook',_kl('Busan','Gamcheon Culture Village tour'),'彩色房屋、壁畫藝術','1.5小時'),
      V('廣安里海灘','Gwangalli Beach','廣安大橋夜景著名海灘','免費','Klook',_kl('Busan','Gwangalli beach night view'),'廣安大橋夜景','1小時'),
    ],
    'Jeju Island': [
      V('城山日出峰','Seongsan Ilchulbong Peak','韓國世界遺產，古火山口日出景觀','₩5,000','Klook',_kl('Jeju','Seongsan Ilchulbong sunrise tour'),'日出景觀、古火山口','2小時'),
      V('涉地可支','Seopjikoji','電影《建築學概論》取景地，草原海岸景觀','免費','Klook',_kl('Jeju','Seopjikoji scenic tour'),'燈塔、草原海景','1小時'),
      V('天帝淵瀑布','Cheonjiyeon Waterfall','濟州三大瀑布之一','₩2,500','Klook',_kl('Jeju','waterfall nature tour'),'熔岩地形瀑布','1小時'),
    ],
    'Shanghai': [
      V('外灘','The Bund','上海最著名景點，百年歐式建築群與陸家嘴夜景','免費','Klook',_kl('Shanghai','Bund night tour'),'殖民建築、浦東夜景','1.5小時'),
      V('豫園','Yu Garden','明代古典江南園林，城隍廟商業區','¥40','官方網站','https://www.yuyuan.com.cn/','湖心亭、九曲橋','1.5小時'),
      V('東方明珠塔','Oriental Pearl Tower','上海標誌性地標，觀景台及旋轉餐廳','¥180起','官方網站','https://www.orientalpearltower.com/','168米球形觀景台','1小時'),
    ],
    'Beijing': [
      V('天安門廣場','Tiananmen Square','全球最大廣場，毛主席紀念堂','免費','Klook',_kl('Beijing','Tiananmen Square Forbidden City tour'),'升旗儀式、人民英雄紀念碑','1小時'),
      V('萬里長城','Great Wall of China','世界七大奇觀，八達嶺或慕田峪段','¥65起','Klook',_kl('Beijing','Great Wall badaling mutianyu tour'),'古代防禦工事、山頂景觀','半日'),
      V('天壇公園','Temple of Heaven','明清皇帝祭天聖地，圜丘壇','¥35','官方網站','https://www.tiantanpark.com/en/','圜丘壇、祈年殿','1.5小時'),
    ],
    'Chengdu': [
      V('成都大熊貓繁育研究基地','Chengdu Panda Base','全球最重要大熊貓保護機構','¥90起','Klook',_kl('Chengdu','Giant Panda Base ticket tour'),'幼年熊貓、滾滾','3小時'),
      V('寬窄巷子','Wide and Narrow Alley','成都最著名歷史街區，川菜小吃聚集','免費','Klook',_kl('Chengdu','Wide Narrow Alley food tour'),'四川特色小吃、茶館','1.5小時'),
      V('武侯祠','Wuhou Shrine','紀念三國諸葛亮的歷史聖地','¥60','官方網站','https://www.wuhouci.net.cn/en/','蜀漢歷史文物','1.5小時'),
    ],
    'Guangzhou': [
      V('廣州塔小蠻腰','Canton Tower','全球最高觀景塔之一（600米）','¥150起','官方網站','https://www.cantontower.com/','頂層玻璃走廊、城市夜景','1小時'),
      V('長隆旅遊度假區','Chimelong Tourist Resort','亞洲頂級度假園區，含動物園及主題樂園','¥280起','官方網站','https://www.chimelong.com/','大熊貓、歡樂世界過山車','1日'),
    ],
    'Shenzhen': [
      V('世界之窗','Window of the World','縮小版全球著名景點主題公園','¥180起','Klook',_kl('Shenzhen','Window of the World ticket'),'世界建築縮影','1日'),
      V('大梅沙海濱公園','Da Mei Sha Beach Park','深圳最長的海灘公園','免費','Klook',_kl('Shenzhen','Dameisha beach day trip'),'藍色海灘、水上活動','半日'),
    ],
    'Bangkok': [
      V('大皇宮及玉佛寺','Grand Palace & Wat Phra Kaew','泰國最神聖的皇家宮殿建築群','฿500','官方網站','https://www.royalgrandpalace.th/','玉佛寺、皇家建築','2小時'),
      V('臥佛寺','Wat Pho','曼谷最古老寺廟，全長46米臥佛','฿200','官方網站','https://www.watpho.com/','金色大臥佛、傳統泰式按摩','1小時'),
      V('考山路','Khao San Road','曼谷最著名背包客街，夜市及街頭表演','免費','Klook',_kl('Bangkok','Khao San Road night tour food'),'夜市小吃、街頭藝術','1.5小時'),
    ],
    'Phuket': [
      V('查龍寺','Wat Chalong','普吉島最重要佛教寺廟','免費','Klook',_kl('Phuket','Wat Chalong temple tour'),'泰式佛塔、佛教文化','1小時'),
      V('普吉大佛','Phuket Big Buddha','高45米的大佛雕像，俯瞰全島','免費','Klook',_kl('Phuket','Big Buddha viewpoint tour'),'全島360度景觀','1小時'),
      V('攀牙灣','Phang Nga Bay','石灰岩島嶼海灣，007電影取景地','฿700起','Klook',_kl('Phuket','Phang Nga Bay day trip James Bond Island'),'占士邦島、海上獨木舟','1日'),
      V('西蒙人妖秀','Simon Cabaret Phuket','普吉島最著名人妖歌舞表演','฿800起','Klook',_kl('Phuket','Simon Cabaret show ticket'),'華麗服裝歌舞秀','1.5小時'),
    ],
    'Chiang Mai': [
      V('素貼山雙龍寺','Doi Suthep Temple','清邁最著名寺廟，山頂俯瞰全城','฿50','Klook',_kl('Chiang Mai','Doi Suthep temple tour'),'金色佛塔、城市全景','1.5小時'),
      V('清邁週日夜市','Chiang Mai Sunday Walking Street','清邁最大傳統手工藝及美食夜市','免費','Klook',_kl('Chiang Mai','Sunday Night Bazaar walking street food'),'傳統手工藝、泰北小吃','2小時'),
      V('大象保護區','Elephant Sanctuary Chiang Mai','倫理大象保護體驗，餵食洗澡','฿2,000起','Klook',_kl('Chiang Mai','ethical elephant sanctuary tour'),'大象餵食、河中洗澡','半日'),
    ],
    'Bali': [
      V('海神廟','Tanah Lot Temple','巴厘島最著名海上寺廟，日落景觀','IDR 60,000','Klook',_kl('Bali','Tanah Lot temple sunset tour'),'海上廟宇日落','1小時'),
      V('烏布皇宮','Ubud Palace','巴厘島最重要的皇室宮殿','免費','Klook',_kl('Bali','Ubud Palace Kecak fire dance'),'傳統克差火舞表演','1.5小時'),
      V('梯田景觀','Tegallalang Rice Terrace','巴厘島著名梯田世界遺產農業景觀','IDR 50,000','Klook',_kl('Bali','Tegallalang rice terrace Ubud tour'),'翠綠梯田、峽谷景觀','1.5小時'),
    ],
    'Kuala Lumpur': [
      V('雙子塔','Petronas Twin Towers','全球曾最高雙子塔，天橋及觀景台','RM88','官方網站','https://www.petronastwintowers.com.my/visit-us/sky-bridge-observatory-deck/','天橋、88樓觀景台','1小時'),
      V('峇都洞穴','Batu Caves','世界最著名印度教神廟洞穴，272級彩色台階','免費','官方網站','https://www.batucaves.org/','黃金雕像、神廟洞穴','1.5小時'),
      V('吉隆坡鳥園','KL Bird Park','全球最大自由放養鳥園','RM67','官方網站','https://klbirdpark.com/','犀鳥、孔雀等300+種鳥類','2小時'),
    ],
    'Singapore': [
      V('濱海灣花園','Gardens by the Bay','超擎天樹光影秀及玻璃溫室','S$28（溫室）','官方網站','https://www.gardensbythebay.com.sg/en/visit-us/getting-here-and-ticketing.html','超級擎天樹夜間光影秀','2小時'),
      V('聖淘沙島','Sentosa Island','新加坡度假聖地，含海灘及主題樂園','S$1起（入島）','Klook',_kl('Singapore','Sentosa Island attraction pass'),'環球影城、海灘','1日'),
      V('濱海灣金沙天空公園','Marina Bay Sands SkyPark','無邊際泳池（住客）及觀景台','S$32（觀景台）','官方網站','https://www.marinabaysands.com/sands-skypark.html','城市全景、無邊際泳池','1小時'),
    ],
    'Ho Chi Minh City': [
      V('古芝地道','Cu Chi Tunnels','越戰時期地下隧道系統','VND 150,000','Klook',_kl('Ho Chi Minh City','Cu Chi Tunnels tour'),'戰時地下隧道體驗','3小時'),
      V('戰爭遺跡博物館','War Remnants Museum','展示越戰歷史的深刻博物館','VND 40,000','官方網站','https://baotangchungtichchientranh.vn/','美軍裝備及歷史文獻','1.5小時'),
      V('統一宮','Reunification Palace','越戰終結地，保留1970年代原貌','VND 40,000','官方網站','https://dinhdoclap.gov.vn/en/','冷戰指揮室、總統寢室','1小時'),
    ],
    'Hanoi': [
      V('河內文廟','Temple of Literature','越南最古老大學，建於1070年','VND 30,000','官方網站','https://vanmieu.vn/en/','龜形石碑、傳統建築','1小時'),
      V('下龍灣一日遊','Ha Long Bay Day Cruise','聯合國教科文組織世界遺產','VND 1,700,000起','Klook',_kl('Hanoi','Ha Long Bay day cruise'),'石灰岩奇峰、翡翠海灣','1日'),
      V('還劍湖','Hoan Kiem Lake','河內市中心湖泊，玉山祠及龍橋','免費','Klook',_kl('Hanoi','Hoan Kiem Lake Old Quarter walking tour'),'玉山祠、老街','1小時'),
    ],
    'Da Nang': [
      V('峴港黃金橋','Golden Bridge Da Nang','巨手托起的黃金拱橋，網紅打卡景點','VND 200,000起','Klook',_kl('Da Nang','Golden Bridge Ba Na Hills ticket'),'巴拿山纜車、法式小鎮','半日'),
      V('峴港美溪海灘','My Khe Beach','越南最美海灘之一，白沙碧海','免費','Klook',_kl('Da Nang','My Khe beach water sports'),'白色沙灘、衝浪','2小時'),
      V('會安古城','Hoi An Ancient Town','世界遺產古城，彩色燈籠及傳統建築','免費（景點票VND 120,000）','Klook',_kl('Da Nang Hoi An','Hoi An ancient town lantern night tour'),'彩色燈籠夜市、古城河畔','半日'),
    ],
    'Siem Reap': [
      V('吳哥窟','Angkor Wat','全球最大宗教建築，世界七大奇觀','US$37起（1日通票）','Klook',_kl('Siem Reap','Angkor Wat temple complex sunrise tour'),'日出石雕、護城河','半日'),
      V('巴戎廟','Bayon Temple','216張神秘微笑石臉的佛教廟宇','含吳哥通票','Klook',_kl('Siem Reap','Bayon Temple Angkor Thom tour'),'216座巨型石臉','1.5小時'),
      V('塔普倫寺','Ta Prohm Temple','樹根侵入廢墟的神秘叢林廟宇（電影取景地）','含吳哥通票','Klook',_kl('Siem Reap','Ta Prohm jungle temple tour'),'古廟叢林、電影取景地','1.5小時'),
    ],
    'Manila': [
      V('因特拉穆羅斯','Intramuros Manila','菲律賓首都殖民時代城牆古城','PHP75','Klook',_kl('Manila','Intramuros walled city bamboo bike tour'),'聖地亞哥城堡、竹單車遊','1.5小時'),
      V('馬拉卡南宮','Malacañan Palace','菲律賓總統官邸及博物館','免費（需預約）','官方網站','https://www.op.gov.ph/malacanan-palace','總統廳、歷史展廊','1小時'),
    ],
    'Cebu': [
      V('聖嬰大殿','Basilica del Santo Niño','菲律賓最古老教堂（1565年建）','免費','Klook',_kl('Cebu','Santo Nino Basilica church tour'),'聖嬰雕像、西班牙殖民建築','1小時'),
      V('鯨鯊共遊','Oslob Whale Shark Swimming','鯨鯊共遊體驗，宿霧最受歡迎景點','PHP1,500起','Klook',_kl('Cebu','whale shark swimming Oslob tour'),'與鯨鯊共泳','2小時'),
    ],
    'New Delhi': [
      V('泰姬陵','Taj Mahal Agra','世界七大奇觀，蒙兀兒帝國愛情見證','₹1,100起（外國人）','Klook',_kl('New Delhi Agra','Taj Mahal day trip tour'),'白色大理石陵墓、日出景觀','半日'),
      V('紅堡','Red Fort Delhi','蒙兀兒帝國皇宮，世界遺產','₹600（外國人）','官方網站','https://www.asiagateways.com/red-fort-delhi/','紅色沙岩宮殿建築群','1.5小時'),
      V('蓮花寺','Lotus Temple Delhi','巴哈伊教蓮花形建築，免費參觀','免費','官方網站','https://www.bahaihouseofworship.in/','白色蓮花建築、靜修','1小時'),
    ],
    'Mumbai': [
      V('印度門','Gateway of India Mumbai','孟買最著名地標，維多利亞港口拱門','免費','Klook',_kl('Mumbai','Gateway of India tour Elephanta Caves'),'巴士岩石島大象廟遊覽','1.5小時'),
      V('達拉維貧民窟','Dharavi Slum Mumbai','全球最大貧民窟之一，社區導覽','₹1,000起','Klook',_kl('Mumbai','Dharavi slum tour local guide'),'手工業區、社區生活','2小時'),
    ],
    'Dubai': [
      V('哈利法塔觀景台','Burj Khalifa At the Top','全球最高建築觀景台（124樓/148樓）','AED149起','官方網站','https://www.atthetop.ae/','全城景觀、日落','1小時'),
      V('杜拜購物中心','Dubai Mall','全球最大購物中心，含水族館及溜冰場','免費入場','官方網站','https://www.thedubaimall.com/','室內水族館、溜冰場','2–3小時'),
      V('杜拜沙漠之旅','Dubai Desert Safari','4WD沙丘衝浪、騎駱駝及貝都因晚餐','AED150起','Klook',_kl('Dubai','desert safari camel riding BBQ dinner'),'沙丘衝浪、阿拉伯晚餐','半日'),
    ],
    'Abu Dhabi': [
      V('謝赫扎耶德大清真寺','Sheikh Zayed Grand Mosque','全球最大清真寺之一，白色大理石建築','免費（著裝要求）','官方網站','https://www.szgmc.gov.ae/en/visitor-information','7萬人容量、波斯地毯','1.5小時'),
      V('盧浮宮阿布扎比','Louvre Abu Dhabi','阿拉伯首座世界級藝術博物館','AED63','官方網站','https://www.louvreabudhabi.ae/en/visit','穿孔圓頂、環球藏品','2小時'),
    ],
    'Istanbul': [
      V('藍色清真寺','Blue Mosque','鄂圖曼帝國宏偉清真寺，6座宣禮塔','免費（著裝要求）','官方網站','https://sultanahmetcamii.org/en/','伊茲尼克磁磚、彩色圓頂','1小時'),
      V('聖索菲亞大教堂','Hagia Sophia','拜占庭建築奇蹟，1500年歷史','免費（祈禱時段除外）','官方網站','https://ayasofyacamii.gov.tr/','黃金馬賽克聖母像','1小時'),
      V('大巴扎','Grand Bazaar','全球最古老最大室內市場','免費','官方網站','https://www.grandbazaaristanbul.org/en/','4,000個攤位、地毯、金飾','1.5小時'),
    ],
    'Rome': [
      V('羅馬競技場','Colosseum','古羅馬最大圓形劇場，世界七大奇觀','€18','官方網站','https://parcocolosseo.it/en/venue/colosseum/','地下迷宮、競技場遺跡','1.5小時'),
      V('梵蒂岡城','Vatican City','全球最小國家，含聖彼得大教堂','免費（廣場）','官方網站','https://www.vaticanstate.va/en/','聖彼得廣場、米開朗基羅圓頂','2小時'),
      V('特雷維噴泉','Trevi Fountain','世界最大巴洛克噴泉，投幣許願','免費','官方網站','https://www.rome.info/attractions/trevi-fountain/','投幣許願、夜景','30分鐘'),
    ],
    'Venice': [
      V('聖馬可廣場','St. Mark\'s Square Venice','威尼斯最著名廣場，聖馬可大教堂','免費（教堂€3）','官方網站','https://www.basilicasanmarco.it/','鐘樓俯瞰、教堂金頂','1.5小時'),
      V('貢多拉遊覽','Gondola Ride Venice','威尼斯傳統貢多拉遊運河','€80起（6人）','Klook',_kl('Venice','gondola ride Grand Canal serenade'),'大運河、窄巷水道','30分鐘'),
      V('玻璃島穆拉諾','Murano Glass Island','威尼斯玻璃工藝發源地，可觀摩工匠吹製','免費（渡輪另計）','Klook',_kl('Venice','Murano Burano island day trip'),'玻璃工藝示範、彩色島','半日'),
    ],
    'Florence': [
      V('烏菲茲美術館','Uffizi Gallery','全球最重要文藝復興藝術館','€20','官方網站','https://www.uffizi.it/en/the-uffizi','波提切利《春》、達文西','2–3小時'),
      V('佛羅倫斯大教堂','Florence Cathedral (Duomo)','文藝復興建築奇蹟，布魯內萊斯基圓頂','免費（圓頂€18）','官方網站','https://www.ilgrandemuseodelduomo.it/en/il-museo','500年玫瑰圓頂、市政廳','1.5小時'),
    ],
    'Barcelona': [
      V('聖家堂','Sagrada Família','高第未完成傑作，預計2026年完工','€29','官方網站','https://sagradafamilia.org/en/tickets','中殿彩色玻璃窗、塔樓','1.5小時'),
      V('奎爾公園','Park Güell','高第奇幻馬賽克公園','€10','官方網站','https://parkguell.barcelona/en/buy-tickets/','彩色馬賽克長椅','1小時'),
      V('蘭布拉大道','La Rambla','巴塞隆拿最著名步行街','免費','官方網站','https://www.barcelona.cat/internationalwelcome/en/discover-barcelona-rambla','街頭藝術、鮮花市場','1小時'),
    ],
    'Amsterdam': [
      V('運河遊船','Amsterdam Canal Cruise','遊覽世界遺產運河網絡','€17起','Klook',_kl('Amsterdam','canal cruise boat tour'),'阿姆斯特丹運河建築','1小時'),
      V('阿姆斯特丹木鞋工廠','Zaanse Schans Windmill Village','傳統風車村，體驗木鞋製作及乳酪','€18','Klook',_kl('Amsterdam','Zaanse Schans windmill tour'),'荷蘭風車、木鞋制作','2小時'),
    ],
    'Vienna': [
      V('美泉宮','Schönbrunn Palace','哈布斯堡王朝夏宮，世界遺產','€21起','官方網站','https://www.schoenbrunn.at/en/','皇家大花園、美泉宮迷宮','2小時'),
      V('聖斯特凡大教堂','Stephansdom','維也納城市標誌，哥德式建築','€6（塔樓）','官方網站','https://www.stephanskirche.at/en/','南塔頂360度全景','1小時'),
    ],
    'Prague': [
      V('布拉格舊城廣場','Old Town Square Prague','天文鐘報時及哥德式廷恩教堂','免費','官方網站','https://www.prague.eu/en/object/tourist-sites/1039/old-town-square','天文鐘整點報時','1小時'),
      V('查理大橋','Charles Bridge','布拉格最著名14世紀石橋，30座聖人雕像','免費','官方網站','https://www.prague.eu/en/object/tourist-sites/1012/charles-bridge','聖人雕像、伏爾塔瓦河景','45分鐘'),
    ],
    'Milan': [
      V('米蘭大教堂','Duomo di Milano','哥德式建築奇蹟，登頂俯瞰米蘭','€7起','官方網站','https://www.duomomilano.it/en/','天台景觀、雕像','1.5小時'),
      V('斯福爾扎城堡','Sforza Castle Milan','米蘭歷史城堡，含博物館','免費（博物館€5）','官方網站','https://www.milanocastello.it/en/','文藝復興城堡、城市公園','1.5小時'),
    ],
    'Athens': [
      V('雅典衛城','Acropolis Athens','古希臘最重要遺址，帕特農神廟','€30','官方網站','https://www.theacropolismuseum.gr/en','帕特農神廟、雅典全景','2小時'),
      V('古市集廢墟','Ancient Agora Athens','蘇格拉底曾在此哲學論辯的古廣場','€10','官方網站','https://www.culture.gov.gr/en/','古希臘民主發源地','1小時'),
    ],
    'Lisbon': [
      V('聖喬治城堡','Castelo de São Jorge Lisbon','里斯本最古老城堡，俯瞰全城及特茹河','€15','官方網站','https://castelodesaojorge.pt/en/','城堡塔樓全景、橄欖樹','1小時'),
      V('貝倫塔','Belém Tower Lisbon','葡萄牙海上探索時代的世界遺產','€6','官方網站','https://www.torrebelem.gov.pt/en/','大航海時代地標、特茹河','1小時'),
      V('發現者紀念碑','Monument to the Discoveries','紀念葡萄牙大航海時代的地標建築','€3','官方網站','https://www.padraodosdescobrimentos.pt/en/','達伽馬、麥哲倫雕像','1小時'),
    ],
    'Budapest': [
      V('布達城堡','Buda Castle Hungary','俯瞰多瑙河的哈布斯堡皇家城堡（世界遺產）','免費（博物館另計）','Klook',_kl('Budapest','Buda Castle fisherman bastion tour'),'漁人堡、城市全景','2小時'),
      V('匈牙利國會大廈','Hungarian Parliament Building','歐洲最大議會建築，多瑙河畔宏偉景觀','HUF6,000起','官方網站','https://www.parlament.hu/web/visitors','哥德式議會廳、聖斯特凡王冠','1小時'),
    ],
    'Copenhagen': [
      V('小美人魚雕像','The Little Mermaid Copenhagen','安徒生童話啟發的著名銅像','免費','官方網站','https://www.visitcopenhagen.com/','港口銅像','30分鐘'),
      V('蒂沃利花園','Tivoli Gardens','全球最古老主題樂園，1843年建','DKK145起','官方網站','https://www.tivoli.dk/en/visit/prices','木製過山車、魔術秀','半日'),
      V('羅森堡城堡','Rosenborg Castle','丹麥皇家珠寶收藏地，17世紀文藝復興城堡','DKK130','官方網站','https://www.kongernessamling.dk/rosenborg/','丹麥皇冠、珠寶','1小時'),
    ],
    'Stockholm': [
      V('舊城區老城','Gamla Stan Stockholm','斯堪的納維亞保存最完整的中世紀老城','免費','Klook',_kl('Stockholm','Gamla Stan Old Town walking tour'),'皇宮衛兵換崗、鵝卵石街道','1.5小時'),
      V('瓦薩號博物館','Vasa Museum','17世紀沉船真跡','SEK190','官方網站','https://www.vasamuseet.se/en','64炮沉船、皇家文物','1.5小時'),
    ],
    'Berlin': [
      V('勃蘭登堡門','Brandenburg Gate Berlin','柏林最著名地標，德國統一象徵','免費','Klook',_kl('Berlin','Brandenburg Gate historical city walk tour'),'新古典主義凱旋門','30分鐘'),
      V('柏林圍牆紀念館','Berlin Wall Memorial','東西德分裂歷史見證','免費','官方網站','https://www.berliner-mauer-gedenkstaette.de/en/','圍牆遺址、歷史展覽','1小時'),
      V('博物館島','Museum Island Berlin','五座世界級博物館聚集於同一島嶼','€18起','官方網站','https://www.smb.museum/en/museums-institutions/museumsinsel-berlin/','奈費爾提蒂半身像','半日'),
    ],
    'London': [
      V('倫敦塔','Tower of London','英格蘭最重要歷史建築，皇家珠寶','£29','官方網站','https://www.hrp.org.uk/tower-of-london/visit/prices/','皇家珠寶、衛兵','2小時'),
      V('倫敦眼','London Eye','高135米摩天輪，泰晤士河畔全景','£35起','官方網站','https://www.londoneye.com/tickets/','倫敦城市全景','30分鐘'),
      V('白金漢宮','Buckingham Palace','英國皇室正式官邸，衛兵換崗儀式','免費（換崗）/£30（夏季開放）','官方網站','https://www.rct.uk/visit/buckingham-palace','衛兵換崗、皇家宴會廳','1小時'),
    ],
    'Paris': [
      V('埃菲爾鐵塔','Eiffel Tower','巴黎最著名地標，夜間燈光秀','€29（頂層）','官方網站','https://www.toureiffel.paris/en/rates-opening-times','城市全景、整點燈光秀','1.5小時'),
      V('凡爾賽宮','Palace of Versailles','歐洲最宏偉的皇家宮殿','€20','官方網站','https://en.chateauversailles.fr/plan-my-visit/prices','鏡廳、凡爾賽花園','半日'),
      V('聖母院','Notre-Dame Cathedral Paris','哥德式建築奇蹟（2025年重開）','免費','官方網站','https://www.notredamedeparis.fr/en/','鐘樓、玫瑰窗（修復後）','1小時'),
    ],
    'Sydney': [
      V('雪梨歌劇院','Sydney Opera House','世界最著名建築，UNESCO世界遺產','A$25起（導覽）','官方網站','https://www.sydneyoperahouse.com/visit/tickets-and-entry','帆形屋頂、港口景觀','1小時'),
      V('雪梨海港大橋攀登','Sydney Harbour Bridge Climb','攀登著名拱形大橋，俯瞰海港全景','A$174起','官方網站','https://www.bridgeclimb.com/','海港360度全景','3.5小時'),
      V('邦迪海灘','Bondi Beach Sydney','澳洲最著名海灘，海岸漫步','免費','Klook',_kl('Sydney','Bondi Beach coastal walk surf lesson'),'白沙藍海、衝浪','半日'),
    ],
    'Melbourne': [
      V('菲利普島企鵝歸巢','Phillip Island Penguin Parade','全球最著名小藍企鵝每晚歸巢景觀','A$30起','官方網站','https://www.penguins.org.au/','小藍企鵝歸巢','2小時'),
      V('大洋路十二使徒岩','Great Ocean Road 12 Apostles','世界最著名海岸公路及石灰岩海蝕柱','A$100起（一日遊）','Klook',_kl('Melbourne','Great Ocean Road 12 Apostles day trip'),'十二使徒岩、坎貝爾峽谷','1日'),
    ],
    'Gold Coast': [
      V('衝浪者天堂','Surfers Paradise Gold Coast','黃金海岸最著名海灘及購物街','免費','Klook',_kl('Gold Coast','Surfers Paradise beach activities'),'金色沙灘、夜市','2小時'),
    ],
    'Auckland': [
      V('天空塔','Sky Tower Auckland','南半球最高獨立式建築，高空彈跳','NZ$32起','官方網站','https://www.skycityauckland.co.nz/attractions/sky-tower/','城市全景、高空彈跳','1小時'),
      V('懷特瑪塔港','Waitemata Harbour Auckland','乘船遊覽奧克蘭海港及諸多島嶼','NZ$50起','Klook',_kl('Auckland','harbour cruise islands tour'),'火山島、帆船文化','2小時'),
    ],
    'Queenstown': [
      V('米爾福德峽灣','Milford Sound Queenstown','全球最著名峽灣，世界遺產','NZ$89起','Klook',_kl('Queenstown Milford Sound','cruise scenic flight tour'),'瀑布、海豚、峽灣','半日'),
      V('皇后鎮高空跳傘','Skydive Queenstown','全球最美高空跳傘地點之一','NZ$299起','Klook',_kl('Queenstown','skydive bungee jump adventure'),'高空俯瞰冰山湖泊','20分鐘跳躍'),
    ],
    'Vancouver': [
      V('卡皮拉諾吊橋','Capilano Suspension Bridge','懸掛70米高的巨型吊橋，林中步道','CAD63起','官方網站','https://www.capbridge.com/visit/admission-prices/','雨林樹頂漫步','2小時'),
      V('惠斯勒小鎮','Whistler Village','北美最著名滑雪及度假勝地','免費（滑雪另計）','Klook',_kl('Vancouver','Whistler day trip gondola sightseeing'),'峰頂纜車、滑雪','1日'),
    ],
    'Toronto': [
      V('CN塔','CN Tower Toronto','全球曾最高塔，玻璃地板觀景台','CAD43起','官方網站','https://www.cntower.ca/plan-your-visit/ticket-types','玻璃地板、城市全景','1小時'),
      V('尼亞加拉瀑布','Niagara Falls from Toronto','全球最大瀑布群，霧中少女號遊船','CAD$30起（一日遊）','Klook',_kl('Toronto','Niagara Falls day trip Maid of the Mist'),'霧中少女號、彩虹瀑布','1日'),
    ],
    'New York': [
      V('自由女神像','Statue of Liberty New York','美國最著名地標，自由島渡輪','US$24起','官方網站','https://www.nps.gov/stli/planyourvisit/fees.htm','自由島、埃利斯島','3小時'),
      V('中央公園','Central Park NYC','全球最著名城市公園，843英畝','免費','Klook',_kl('New York','Central Park walking bike tour'),'步行/單車遊覽','2小時'),
      V('時代廣場','Times Square NYC','紐約最著名地標，霓虹廣告牌','免費','Klook',_kl('New York','Times Square walking night tour'),'百老匯、霓虹夜景','1小時'),
    ],
    'Los Angeles': [
      V('好萊塢星光大道','Hollywood Walk of Fame','全球最著名名人手印及星形徽章','免費','Klook',_kl('Los Angeles','Hollywood Walk of Fame tour celebrity homes'),'明星手印、中國劇院','1小時'),
      V('聖莫尼卡碼頭','Santa Monica Pier','洛杉磯著名海岸碼頭及遊樂場','免費','Klook',_kl('Los Angeles','Santa Monica beach pier cycling'),'太平洋摩天輪、日落','2小時'),
    ],
    'Las Vegas': [
      V('拉斯維加斯大道','Las Vegas Strip','全球最璀璨賭城大道，酒店奇觀','免費','Klook',_kl('Las Vegas','Strip hotel tour night experience'),'噴泉秀、酒店大廳','2小時'),
      V('大峽谷之旅','Grand Canyon from Las Vegas','世界七大自然奇觀，科羅拉多河','US$99起','Klook',_kl('Las Vegas','Grand Canyon day tour helicopter'),'直升機飛越、峽谷景觀','1日'),
    ],
    'Honolulu': [
      V('珍珠港紀念館','Pearl Harbor Hawaii','二戰歷史聖地，亞利桑那號紀念館','US$1起（渡輪）','官方網站','https://www.nps.gov/perl/planyourvisit/fees.htm','亞利桑那號沉船、USS密蘇里','3小時'),
      V('鑽石山頭','Diamond Head State Monument','著名死火山，俯瞰檀香山','US$5','官方網站','https://dlnr.hawaii.gov/dsp/parks/oahu/diamond-head-state-monument/','登頂全景、太平洋海景','1.5小時'),
    ],
    'Cancun': [
      V('奇琴伊察','Chichen Itza from Cancun','馬雅文明最重要遺址，世界七大奇觀','MXN$672起（外國人）','Klook',_kl('Cancun','Chichen Itza day trip Maya ruins'),'羽蛇神金字塔','1日'),
      V('科蘇梅爾島潛水','Cozumel Island Snorkeling Cancun','加勒比海最著名珊瑚礁潛水地點','US$50起','Klook',_kl('Cancun','Cozumel island snorkeling dive tour'),'加勒比海珊瑚礁','1日'),
    ],
    'Cape Town': [
      V('桌山纜車','Table Mountain Cable Car Cape Town','南非最著名地標，平頂山頂纜車','ZAR380起','官方網站','https://www.tablemountain.net/content/cable-car','俯瞰開普敦及大西洋','1小時'),
      V('好望角','Cape of Good Hope Day Trip','非洲最南端地標，企鵝保護區','ZAR390起','Klook',_kl('Cape Town','Cape of Good Hope day trip penguin colony'),'非洲企鵝、非洲最南端','1日'),
    ],
    'Cairo': [
      V('吉薩金字塔','Giza Pyramids Cairo','世界七大奇觀，古代世界唯一留存的奇觀','EGP540起（外國人）','Klook',_kl('Cairo','Giza Pyramids Sphinx camel ride tour'),'大金字塔、獅身人面像、駱駝','3小時'),
      V('埃及博物館','Egyptian Museum Cairo','全球最重要古埃及文物博物館','EGP200','官方網站','https://egyptianmuseum.gov.eg/','圖坦卡門黃金面具','2–3小時'),
    ],
    'Marrakech': [
      V('馬拉喀什麥地那舊城','Marrakech Medina Souk','聯合國教科文組織世界遺產舊城及迷宮集市','免費','Klook',_kl('Marrakech','Medina souk walking food tour'),'香料市集、皮革染坊','2小時'),
      V('巴希亞宮','Bahia Palace Marrakech','19世紀摩洛哥皇宮，精美伊斯蘭馬賽克','MAD70','官方網站','https://www.bahia-palace.com/','摩洛哥庭院建築','1小時'),
    ],
  },
};
